import "core-js/modules/es.array.map";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        from_appid: "",
        to_appid: ""
      },
      rules: {
        from_appid: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        to_appid: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getcommonData(['appListAllData']);

              case 2:
                _this.copyPrimitive();

                if (data) {
                  _this.formData = _objectSpread({}, data);
                }

                _this.copyData();

                _this.initappList();

                _this.dialogFormVisible = true;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    initappList: function initappList() {
      var _this2 = this;

      this.appListAllData.map(function (i) {
        i.disabled = _this2.formData.from_appid == i.appid ? true : false;
      });
    },
    fromAppidChange: function fromAppidChange(e) {
      this.appListAllData.map(function (i) {
        i.disabled = i.appid == e ? true : false;
      });
      this.formData.to_appid = e == this.formData.to_appid ? '' : this.formData.to_appid;
    },
    clearDataTow: function clearDataTow() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
      this.initappList();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 6;
                    break;
                  }

                  if (!_this3.formData.id) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return _this3.secondConfirmation();

                case 4:
                  reqFn = _this3.formData.id ? 'appLoginReplaceListUpdate' : 'appLoginReplaceListAdd';

                  _this3.$api[reqFn](_this3.formData).then(function (res) {
                    if (res.status == 200) {
                      _this3.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this3.dialogFormVisible = false;

                      _this3.$emit('change');
                    }
                  });

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};